import React from "react";

interface BasicLayoutProps {
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
}

const BasicLayout = ({
  children,
  className,
  style,
}: BasicLayoutProps): React.ReactElement => {
  return (
    <div
      className={`flex justify-center overflow-auto flex-1 ${className || ""}`}
      style={style}
    >
      {children}
    </div>
  );
};

export default BasicLayout;
